import BadgeList from "../../components/BadgeList";

function MemberBadges({ badges }) {
  return <BadgeList badges={badges} />;
}

export default MemberBadges;
